import { render, staticRenderFns } from "./signStatistics.vue?vue&type=template&id=408f57d8&scoped=true&"
import script from "./signStatistics.vue?vue&type=script&lang=js&"
export * from "./signStatistics.vue?vue&type=script&lang=js&"
import style0 from "./signStatistics.vue?vue&type=style&index=0&id=408f57d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408f57d8",
  null
  
)

export default component.exports